export default __webpack_public_path__ + "static/media/icon_mydata_inprogress.ba8b5f89.svg";